import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';
import { Translate, I18n } from 'react-redux-i18n';
import QRCode from "react-qr-code";
// import { QRCode } from "react-qrcode-logo";
import { saveSvgAsPng } from "save-svg-as-png";

import { Dialog, MenuItem, Collapse } from '@blueprintjs/core';
import { Suggest } from "@blueprintjs/select";
import './MapEditor.scss';

import Modal from '../../components/Modal/Modal';
import LoadingLocal from '../../components/Loading/LoadingLocal';
import Scenario from '../Scenario/Scenario';
import ContributeDialog from './ContributeDialog';

import MapEditor from "./MapEditor";

import auth from '../../auth';
import style from './Scenarios.module.css';

import MultiSelectBox from 'react-multiselect-box'
import 'react-multiselect-box/build/css/index.css'

import logo from '../../assets/img/logo.png';

import {
  openModal as openModalAction,
  closeModal as closeModalAction,
  selectScenario as selectScenarioAction,
  selectRepository as selectRepositoryAction,
  selectRepoSim as selectRepoSimAction,
  importRepoSim as importRepoSimAction,
  downloadScenario as downloadScenarioAction,
  fetchScenarios as fetchScenariosAction,
  addRepo as addRepoAction,
  removeRepo as removeRepoAction,
  fetchRepos as fetchReposAction,
  renameScenario as renameScenarioAction,
  makePublicScenario as makePublicScenarioAction,
  makeUnpublicScenario as makeUnpublicScenarioAction,
  deleteScenario as deleteScenarioAction,
  uploadScenario as uploadScenarioAction,
  setUpdateFlag as setUpdateFlagAction,
  closeError as closeErrorAction,
  changeFilter as changeFilterAction,
  resetFilter as resetFilterAction,
  exportCompanyScenarios as exportCompanyScenariosAction,
  importCompanyScenarios as importCompanyScenariosAction,
  fetchRepoScenarios as fetchRepoScenariosAction,
  openMapEditor as openMapEditorAction,
  closeMapEditor as closeMapEditorAction,
} from './ScenariosActions';

import loginActions from '../Login/LoginActions';

import {
  fetchCompanies as fetchCompaniesAction,
} from '../Users/UsersActions';

import {
  fetchScenario as fetchScenarioAction,
  saveScenarioChanges as saveScenarioChangesAction
} from '../Scenario/ScenarioActions';
import helpers from "../../helpers";

const MAP_VIEW_ENABLED = process.env.REACT_APP_MAP_VIEW_ENABLED;

function Scenarios(props) {
  const dispatch = useDispatch();
  
  const [isContributeDialogOpen, setIsContributeDialogOpen] = useState(false);
  const [isContributeThankyouDialogOpen, setIsContributeThankyouDialogOpen] = useState(false);
  const [companyQuery, setCompanyQuery] = useState('');
  const [isReposOpen, setIsReposOpen] = useState(false);

  const qrcodeRef = useRef(null);
  const hiddenFileInput = useRef(null);

  const {
      loading,
      downloading,
      deleting,
      companies,
      company,
      filter,
      uploading,
      scenarios,
      scenario,
      repositories,
      repoScenarios,
      userData,
      modal,
      currentScenario,
      currentScenarioMapInfo,
      currentRepository,
      currentRepoSim,
      isUpdate,
      error,
      showError,
      curUser,
      mapEditorShown
  } = useSelector(state => ({
    loading: state.scenarios.loading || state.scenarios.loadingCompanies,
    downloading: state.scenarios.downloading,
    deleting: state.scenarios.deleting,
    companies: state.scenarios.companies,
    company: state.company.data,
    filter: state.scenarios.filter,
    uploading: state.scenarios.uploading,
    scenarios: state.scenarios.data,
    scenario: state.scenario.data,
    repositories: state.scenarios.repositories,
    repoScenarios: state.scenarios.repoScenarios,
    userData: state.login.userData,
    modal: state.scenarios.modal,
    currentScenario: state.scenarios.currentScenario,
    currentScenarioMapInfo: state.scenarios.currentScenarioMapInfo,
    currentRepository: state.scenarios.currentRepository,
    currentRepoSim: state.scenarios.currentRepoSim,
    isUpdate: state.scenarios.isUpdate,
    error: state.scenarios.error,
    showError: state.scenarios.showError,
    curUser: state.login.userData,
    mapEditorShown: state.scenarios.mapEditorShown,
  }));

  useEffect(() => {
    if (auth.can('scenario-master')) {
      dispatch(fetchCompaniesAction());
      const user = helpers.getUserFromLocalStorage();
      dispatch(changeFilterAction('company', user.company._id));
    }

    dispatch(loginActions.fetchCurUser());
    dispatch(fetchScenariosAction({}));
    dispatch(fetchReposAction());
    dispatch(fetchRepoScenariosAction());
    dispatch(selectRepositoryAction());

    return () => {
        dispatch(resetFilterAction());
    };
  }, [dispatch]);

  const importCompanyScenarios = (e) => {
    let file = e.target.files[0];
    if (file) {
      if (file.size > process.env.MAX_UPLOAD_MB * 1024 * 1024) {
        alert('File is to big. Maximum uploading file is ' + process.env.MAX_UPLOAD_MB + 'MB')
      }
      else {
        dispatch(importCompanyScenariosAction(e.target.files[0]));
      }

      document.getElementById('import-file-input').value = '';
    }
  }

  const onSelectFile = (e) => {
    if (uploading) return;

    const file = e.target.files[0];

    if (file) {
      if (file.size > process.env.MAX_UPLOAD_MB * 1024 * 1024) {
        alert('File is to big. Maximum uploading file is ' + process.env.MAX_UPLOAD_MB + 'MB')
      }
      else if (isUpdate) {
        dispatch(uploadScenarioAction(filter.company, file, currentScenario));
      } else {
        dispatch(uploadScenarioAction(filter.company, file));
      }
      document.getElementById('upload-sim-input').value = '';
    }
  }

  const changeFilter = (e) => {
    const { id, value } = e.target;
    console.log("CHANGE FILTER", id, value);
    dispatch(changeFilterAction(id, value));
    
    // Using existing logic of fetching after a timeout/update
    // Alternatively passing the new filter directly would be safer
    setTimeout(() => {
        // Constructing the new filter since state implementation of filter update might be async in redux
         // But here we rely on the selector. 
         // If we want to be safe and immediate:
         // dispatch(fetchScenariosAction({ ...filter, [id]: value }));
         // But let's stick closer to original which fetched from props.
         // We can't easily access the "next" props here synchronously after dispatch.
         // We will trust standard redux async flow or pass the modified filter.
         // Since we can't get the updated filter from useSelector immediately, 
         // we should probably manually merge it.
         
         // However, `this.props.filter` in the original was also not guaranteed to be updated 
         // in `setTimeout(..., 0)` unless the store update was synchronous and props propagated.
         // Let's rely on the store action for now, but to be safe, pass the explicit filter.
         let newFilter = { ...filter };
         // The original code passed `this.props.filter` inside the timeout.
         // Let's dispatch the fetch with the new value directly to be safe.
         if (id) newFilter[id] = value;
         dispatch(fetchScenariosAction(newFilter));
    }, 0);
  }

  // Helper for Suggest item select which passes an object with target.
  const changeFilterFromSuggest = (id, value) => {
      // Mimic the event structure expected by changeFilter or call action directly
       console.log("CHANGE FILTER", id, value);
       dispatch(changeFilterAction(id, value));
       setTimeout(() => {
           let newFilter = { ...filter, [id]: value };
           dispatch(fetchScenariosAction(newFilter));
       }, 0);
  }


  const filterScenarios = () => {
    dispatch(fetchScenariosAction(filter));
  }

  const handleSelectChange = (_id, mapInfo) => {
    console.log("Selecting repo with", {_id, mapInfo});
    dispatch(selectScenarioAction({_id, mapInfo}));
  }

  const handleRepoSelectChange = (_id) => {
    dispatch(selectRepositoryAction(_id));
  }

  const handleRepoSimSelectChange = (_id) => {
     dispatch(selectRepoSimAction(_id));
  }

  const openModal = () => {
    dispatch(openModalAction());
    dispatch(fetchScenarioAction(currentScenario));
  }

  const openEmbedded = async () => {
    console.log("OPENING EMBEDDED");
    const user = helpers.getUserFromLocalStorage();

    let comp = filter.company || user.company._id;

    /* let url = `${window.location.origin}/api/scenarios/${comp}/${currentScenario}/archive?token=${localStorage.token}`;
    window.open(`/webclient/?url=${encodeURIComponent(url)}`,
      '_blank', "directories=0,titlebar=0,toolbar=0,location=0,status=0,menubar=0,scrollbars=no,resizable=no,width=430,height=342");

    console.log("URL:", url); */
    
    let url = `${window.location.origin}/api/scenarios/${comp}/${currentScenario}?token=${localStorage.token}`;

    const res = await fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': localStorage.token,
      }
    })

    const data = await res.json();
    console.log("DATA", data);

    window.open(`/webclient/?url=${encodeURIComponent(data.scenario.archiveURL)}&preview-screen=true&allow_evaluations=true`,
      '_blank', "directories=0,titlebar=0,toolbar=0,location=0,status=0,menubar=0,scrollbars=no,resizable=no,width=430,height=342");
  }

  const openEmbeddedFromRepo = async () => {
    console.log("OPENING EMBEDDED FROM REPO");
    const user = helpers.getUserFromLocalStorage();

    // Not used but kept for logic consistency if needed
    // let company = filter.company || user.company._id; 

    /* let url = `${window.location.origin}/api/scenarios/${currentRepository}/${currentRepoSim}/archive?token=${localStorage.token}`;

    window.open(`/webclient/?url=${encodeURIComponent(url)}`,
      '_blank', "directories=0,titlebar=0,toolbar=0,location=0,status=0,menubar=0,scrollbars=no,resizable=no,width=430,height=342"); */

    let url = `${window.location.origin}/api/scenarios/${currentRepository}/${currentRepoSim}?token=${localStorage.token}`;

    const res = await fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': localStorage.token,
      }
    })

    const data = await res.json();
    console.log("DATA", data);

    window.open(`/webclient/?url=${encodeURIComponent(data.scenario.archiveURL)}&preview-screen=true&allow_evaluations=true`,
      '_blank', "directories=0,titlebar=0,toolbar=0,location=0,status=0,menubar=0,scrollbars=no,resizable=no,width=430,height=342");
  }

  const updateScenario = () => {
    dispatch(closeModalAction());
    dispatch(saveScenarioChangesAction(scenario._id, scenario)).then(() => {
      dispatch(fetchScenariosAction({}));
    })
  }

  const download = () => {
    dispatch(downloadScenarioAction(filter.company, currentScenario));
  }

  const deleteSim = () => {
    const currentScenarioInfo = scenarios.find(a => a._id === currentScenario);

    var pubMsg = 'Are you sure you want to delete \"' + currentScenarioInfo.title + '\"?';
    if (currentScenarioInfo.publicURL) {
      pubMsg = "This simulation is marked as embeddable. Deleting it now will remove public access to it permanently. " + pubMsg;
    }

    if (window.confirm(pubMsg)) {
      dispatch(deleteScenarioAction(filter.company, currentScenario));
    }
  }

  const create = () => {
    dispatch(setUpdateFlagAction(false));
    if (hiddenFileInput.current) hiddenFileInput.current.click();
  }

  const update = () => {
    dispatch(setUpdateFlagAction(true));
    if (hiddenFileInput.current) hiddenFileInput.current.click();
  }

  const makePublic = () => {
    dispatch(makePublicScenarioAction(filter, currentScenario));
  }

  const makeUnpublic = () => {
    const currentScenarioInfo = scenarios.find(a => a._id === currentScenario);

    var pubMsg = 'Are you sure you want to disallow embedding for \"' + currentScenarioInfo.title + '\"? ' +
                 'Pressing OK will invalidate any references to it outside the CTC. You may re-allow embedding later but it will generate new codes.';

    if (window.confirm(pubMsg)) {
      dispatch(makeUnpublicScenarioAction(filter, currentScenario));
    }

  }

  const copyFromId = (id) => {
    const copyText = document.getElementById(id);
    copyText.select();
    document.execCommand("copy");
  }

  const rename = () => {
    const user = helpers.getUserFromLocalStorage();
    const companyId = filter.company || user.company._id;

    let scenarioInfo = scenarios.find(s => s._id === currentScenario);
    let newTitle = prompt('New sim name:', scenarioInfo.title);

    if (newTitle.length >= 3) {
      let newId = newTitle.toUpperCase().replace(/[^0-9a-z]/gi, '');

      if ((newId && newId !== '' && newId !== scenarioInfo.id) ||
        (newTitle && newTitle !== '' && newTitle !== scenarioInfo.title)) {
        dispatch(renameScenarioAction(companyId, currentScenario, newId, newTitle));
      }
    } else {
      alert("Sim name must be 3 or more characters!");
    }
  }

  const contribute = () => {
    setIsContributeDialogOpen(true);
  }

  const openMapEditor = () => {
    dispatch(fetchScenarioAction(currentScenario));
    dispatch(openMapEditorAction());
  }

  const addRepo = () => {
    let repoName = prompt('Repo name', '');
    let accessCode = prompt('Access code', '');

    if (repoName && accessCode) {
      dispatch(addRepoAction(repoName, accessCode));
    }
  }

  const removeRepo = () => {
    if (confirm('Are you sure want to remove repository?')) {
      dispatch(removeRepoAction(currentRepository));
    }
  }

  const compareNames = (a, b) => {
    if (a.name > b.name) {
      return 1;
    } else if (b.name > a.name) {
      return -1;
    }
    return 0;
  }
  
  const downloadQrCode = (urlLink, label) => {
    console.log("QRCODE Ref:", qrcodeRef);
    return saveSvgAsPng(qrcodeRef.current, label || "SUS-QRCode");
  }


    // Render Helpers
    const currentScenarioInfo = scenarios ? scenarios.find(a => a._id === currentScenario) : null;
    const isMaster = auth.can('scenario-master');
    const user = helpers.getUserFromLocalStorage();
    const isAdmin = user && user.level === 'admin';
    const isOrganizer = user && user.level === 'organizer';
    const isShared = user && user.level === 'shared';
    const curCompany = (companies && companies.find(c => c._id == company)) || (user && user.company);
    const atSimLimit = scenarios && user && curCompany && scenarios.length >= curCompany.maxSims;

    const companyId = filter.company || (user && user.company && user.company._id);

    // Filter name and company
    const { name } = filter;
    // company is already destructured from state.company.data

    return (
      <div className="row">
        {mapEditorShown && <MapEditor companyId={companyId}/>}
        <div className="col-md-12 mt-4">
          {modal && <Modal onClose={() => dispatch(closeModalAction())} onConfirm={updateScenario}><Scenario/></Modal>}
          <Dialog
            autoFocus={true}
            canEscapeKeyClose={true}
            canOutsideClickClose={true}
            enforceFocus={true}
            isOpen={isContributeDialogOpen}
            usePortal= {true}
            onClose={()=>setIsContributeDialogOpen(false)}
            title="Contribute"
          >
            <ContributeDialog scenario={currentScenario} onClose={(success)=>{
              setIsContributeDialogOpen(false);
              if (success) {
                  // Using setTimeout to allow state update to process
                  setTimeout(()=>{
                    setIsContributeThankyouDialogOpen(true);
                  }, 500);
              }
            }} />
          </Dialog>
          <Dialog
            autoFocus={true}
            canEscapeKeyClose={true}
            canOutsideClickClose={true}
            enforceFocus={true}
            isOpen={isContributeThankyouDialogOpen}
            usePortal= {true}
            onClose={()=>setIsContributeThankyouDialogOpen(false)}
          >
            <div className={style.thankyouDialog}>
              <Translate value="mutualAid.shareThanks" />
            </div>
          </Dialog>
          <h3><strong><Translate value="scenarios.title"/></strong></h3>
          <hr/>
          <Translate value="scenarios.desc"/>
          {error && showError &&
          <div className={`alert alert-danger ${style.errorAlert}`}>
            <a
              className="close"
              onClick={() => dispatch(closeErrorAction())}
            >×</a>
            <strong><Translate value="controls.Error"/>:</strong> {error}
          </div>
          }
          <hr/>
          {isMaster &&
          <div className={style.filterWrapper}>
            <p className={style.title}><Translate value="controls.Filters"/></p>
            <div className={style.filter}>
              <div className="d-flex">
                <div className="d-flex align-items-center">
                  <label className="col-form-label" htmlFor="name"><Translate value="scenario.Name"/></label>
                  <input
                    type="text"
                    className="form-control"
                    id="name"
                    value={name || ''}
                    onChange={changeFilter}
                  />
                </div>
                <div className="d-flex align-items-center">
                  <label className="col-form-label" htmlFor="name">
                    <Translate value="scenario.Company"/>
                  </label>
                  <Suggest
                    id="company"
                    items={(companyQuery? companies.filter((c) => c.name.toLowerCase().includes(companyQuery.toLowerCase())) : (companies || []))}
                    onItemSelect={(item, event) => {console.log("Item selected", item); changeFilterFromSuggest("company", item._id)}}
                    noResults={<MenuItem disabled={true} text="No results." />}
                    itemsEqual={(a, b) => a._id === b._id}
                    onQueryChange={(query) => {setCompanyQuery(query); console.log("Query:", query)}}
                    itemRenderer={(company, { handleClick }) => <MenuItem text={company.name} onClick={handleClick} />}
                    inputValueRenderer={(company) => company.name}
                    selectedItem={(() => {console.log("Default ID:", company); return companies ? companies.find((c) => c._id === company) : null;})()}
                    resetOnQuery={true}
                  />
                </div>
                <div className="d-flex justify-content-end flex-grow-1 align-items-center">
                  <button className="btn btn-primary" onClick={filterScenarios} style={{ height: '28px' }}>
                    <Translate value="controls.Refresh"/>
                  </button>
                </div>
              </div>
            </div>
          </div>
          }
          <h4><strong><Translate value="scenarios.ManageTitle"/></strong></h4>
          <div className="row">
            <div className="col-sm-6">
              {loading && <LoadingLocal/>}
              <div>
                <div
                  className={'select-box'}
                  style={{height: '230px'}}
                >
                  <div value="" hidden/>
                  {
                    scenarios && scenarios.map(scenario => (
                      <div
                        key={scenario._id}
                        value={scenario._id}
                        className={'select-box__variant ' + (currentScenario === scenario._id ? 'select-box__variant--selected' : '')}
                        onClick={() => handleSelectChange(scenario._id, scenario.mapInfo)}
                        onDoubleClick={openEmbedded}
                      >{scenario.title} {scenario.is_public ? '(public)' : ''}</div>
                    ))
                  }
                </div>
              </div>
              <div className={atSimLimit ? style.emphasizeText : ''}>
                {atSimLimit && curCompany ?
                  <Translate value="scenarios.NoMoreSims" maxSims={curCompany.maxSims}/> :
                  (curCompany && <Translate value="scenarios.SimsUsed" currentSims={scenarios ? scenarios.length : 0} maxSims={curCompany.maxSims}/>)
                }
              </div>

            </div>
            <div className="col-sm-6">
              <ul className="nav nav-tabs">
                  <li className="nav-item active">
                      <a href="#general" className="nav-link active" data-bs-toggle="tab">General</a>
                  </li>
                  {
                    !process.env.REACT_APP_HIDE_MANAGE_REPOS &&
                    <li className="nav-item">
                      <a href="#embed" className="nav-link" data-bs-toggle="tab">Sim Embedding</a>
                    </li> 
                  }
                  <li className="nav-item">
                      <a href="#upload" className="nav-link" data-bs-toggle="tab">Upload/Download</a>
                  </li>
              </ul>

              <div className="tab-content">

                  <div className="tab-pane active" id="general" style={{marginTop: '10px', marginBottom: '50px'}}>

                    <button className={`btn btn-primary ${style.btn}`} onClick={openEmbedded}
                            disabled={!currentScenario}>
                      <i className="fas fa-fw fa-eye"/> <Translate value="scenarios.Preview"/>
                    </button>
                    {(isMaster || isAdmin) &&
                      <div>
                        <button className={`btn btn-primary ${style.btn}`} onClick={rename}
                                disabled={!currentScenario || downloading}>
                          <i className={`fas fa-fw ${downloading ? 'fa-circle-o-notch fa-spin' : 'fa-pencil-alt'}`}/> <Translate
                          value="scenarios.Rename"/>
                        </button>
                        {(MAP_VIEW_ENABLED) &&
                        <button className={`btn btn-primary ${style.btn}`} onClick={openMapEditor}
                                disabled={!currentScenario || downloading}>
                                {
                                  !!currentScenarioMapInfo?
                                  <React.Fragment>
                                    <i className={`fa fa-fw ${downloading ? 'fa-circle-o-notch fa-spin' : 'fa-map'}`}/>
                                    <Translate value="scenarios.OpenMapEditor"/>
                                  </React.Fragment>
                                  :
                                  <React.Fragment>
                                    <i className={`fa fa-fw ${downloading ? 'fa-circle-o-notch fa-spin' : 'fa-map'}`}/>
                                    <Translate value="scenarios.OpenMapEditorCreate"/>
                                  </React.Fragment>
                                }
                        </button>}
                        <button className={`btn btn-danger ${style.btn}`} onClick={deleteSim}
                                disabled={!currentScenario || deleting || isOrganizer || isShared}>
                          <i className={`fas fa-fw ${deleting ? 'fa-circle-o-notch fa-spin' : 'fa-trash'}`}/> <Translate
                          value="controls.Delete"/>
                        </button>
                        {
                          !(curUser && curUser.company && curUser.company.hideMutualAid)
                          &&
                          <button
                            className={`btn btn-primary ${style.btn}`}
                            onClick={contribute}
                            disabled={!currentScenario}
                            style={{marginTop: 20, backgroundColor: '#C58900', borderColor: '#C58900', color: 'black'}}
                          >
                            <i className={`fas fa-fw fa-share-alt`}/> <Translate
                            value="scenarios.Contribute"/>
                          </button>

                        }
                      </div>
                    }
                  </div>

                  <div className="tab-pane" id="embed" style={{marginTop: '10px', marginBottom: '50px'}}>
                      {!currentScenarioInfo || !currentScenarioInfo.publicURL &&

                      <button className={`btn btn-primary ${style.btn}`} onClick={makePublic}
                              disabled={!currentScenario || (!isAdmin && !isMaster)}>
                        <i className="fas fa-fw fa-eye"/>Allow Sim Embedding</button>
                      }

                      {currentScenario && currentScenarioInfo && currentScenarioInfo.publicURL &&
                      <div>
                        <div className="row">
                          <div className="col-sm-2">
                          </div>
                          <button className={`btn btn-primary ${style.btn}`} onClick={makeUnpublic}
                              disabled={!currentScenario || !(isMaster || isAdmin)}>
                        <i className="fas fa-fw fa-eye"/>Disallow Sim Embedding</button>
                        </div>
                        <div className="row">
                          <div className="col-sm-2">
                            Link Code:
                          </div>
                          <div className="col-sm-10">
                            {/* <textarea id="linkcode-code" rows="3" readOnly style={{width: "calc(100% - 30px)", marginRight: '15px'}} value={'<center><a href=' + location.origin + '/embeddedplayer?u=' + currentScenarioInfo.publicURL + ' target=_blank>' + currentScenarioInfo.title + '</a></center>'}> */}
                            {/* </textarea> */}
                            <textarea id="linkcode-code" rows="3" readOnly style={{width: "calc(100% - 30px)", marginRight: '15px'}} value={'<center><a href=' + location.origin + '/webclient/?url=' + encodeURIComponent(currentScenarioInfo.archiveURL) + '&preview-screen=true&allow_evaluations=true' + ' target=_blank>' + currentScenarioInfo.title + '</a></center>'}>

                            </textarea>
                            <a href="#" className="fas fa-copy" onClick={() => copyFromId('linkcode-code')}></a>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-sm-2">
                            Email Code:
                          </div>
                          <div className="col-sm-10" style={{whiteSpace: 'prewrap'}}>
                            {/* <input id="share-link" readOnly value={location.origin + '/embeddedplayer?u=' + currentScenarioInfo.publicURL + '&preview-screen=true&allow_evaluations=true'} style={{width: "calc(100% - 30px)", marginRight: '15px'}} /> */}
                            <input id="share-link" readOnly value={location.origin + '/webclient/?url=' + encodeURIComponent(currentScenarioInfo.archiveURL) + '&preview-screen=true&allow_evaluations=true'} style={{width: "calc(100% - 30px)", marginRight: '15px'}} />
                            <a href="#" className="fas fa-copy" onClick={() => copyFromId('share-link')}></a>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-sm-2">
                            iFrame Embed Code:
                          </div>
                          <div className="col-sm-10">
                            {/* <textarea id="embedded-code" rows="3" readOnly style={{width: "calc(100% - 30px)", marginRight: '15px'}} value={'<iframe src=' + location.origin + '/embeddedplayer?u=' + currentScenarioInfo.publicURL + '&preview-screen=true allowfullscreen=allowfullscreen width=400px height=300px ></iframe>'}> */}
                            {/* </textarea> */}
                            <textarea id="embedded-code" rows="3" readOnly style={{width: "calc(100% - 30px)", marginRight: '15px'}} value={'<iframe src=' + location.origin + '/webclient/?url=' + encodeURIComponent(currentScenarioInfo.archiveURL) + '&preview-screen=true&allow_evaluations=true allowfullscreen=allowfullscreen width=400px height=300px ></iframe>'}>

                            </textarea>
                            <a href="#" className="fas fa-copy" onClick={() => copyFromId('embedded-code')}></a>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-sm-2">
                            QR Code:
                          </div>
                          <div className="col-sm-9" style={{whiteSpace: 'prewrap', display: 'flex', justifyContent: 'center', position: 'relative'}}>
                            {/* <QRCode
                              size={window.innerWidth < 550? 128 : 256}
                              value={location.origin + '/embeddedplayer?u=' + currentScenarioInfo.publicURL + '&preview-screen=true'}
                              ref={qrcodeRef}
                            /> */}
                            <QRCode
                              size={window.innerWidth < 550? 128 : 256}
                              value={location.origin + '/webclient/?url=' + encodeURIComponent(currentScenarioInfo.archiveURL) + '&preview-screen=true&allow_evaluations=true'}
                              ref={qrcodeRef}
                            />
                            <div style={{position: "absolute", height: "100%", width: "100%", display: "flex", justifyContent: "center", alignItems: "center"}}>
                              <img src={logo} style={{width: (window.innerWidth < 550? 128 : 256) * 0.5, height: (window.innerWidth < 550? 128 : 256) * 0.1}} />
                            </div>
                          </div>
                          <div className="col-sm-1" style={{display: 'flex', justifyContent: 'flex-end', alignItems: 'center'}}>
                            {/* <a href="#" className="fas fa-download" onClick={() => downloadQrCode(location.origin + '/embeddedplayer?u=' + currentScenarioInfo.publicURL + '&preview-screen=true', currentScenarioInfo.title)}></a> */}
                            <a href="#" className="fas fa-download" onClick={() => downloadQrCode(location.origin + '/webclient/?url=' + encodeURIComponent(currentScenarioInfo.archiveURL) + '&preview-screen=true&allow_evaluations=true', currentScenarioInfo.title)}></a>
                          </div>
                        </div>
                      </div>
                      }
                      {!currentScenario &&
                        <p><i>Click on a sim from the list to enable or disable web sim-embedding.</i></p>
                      }
                  </div>

                  <div className="tab-pane" id="upload" style={{marginTop: '10px', marginBottom: '50px'}}>
                      <button className={`btn btn-primary ${style.btn}`} onClick={download}
                        disabled={!currentScenario || downloading || !(isMaster || isAdmin)}>
                        <i className={`fas fa-fw ${downloading ? 'fa-circle-o-notch fa-spin' : 'fa-download'}`}/> <Translate
                        value="scenarios.Download"/>
                      </button>

                      <button
                        className={`btn btn-primary ${style.btn}`}
                        onClick={create}
                        disabled={uploading || isShared || !(isMaster || isAdmin)}>
                        <i className={`fas fa-fw ${uploading ? 'fa-circle-o-notch fa-spin' : 'fa-plus' }`}/>
                        <Translate value="scenarios.AddZippedSimFolder"/>
                      </button>

                      <input
                        id="upload-sim-input"
                        type="file"
                        accept="application/zip,application/x-zip,application/x-zip-compressed"
                        disabled={!(isMaster || isAdmin)}
                        ref={hiddenFileInput}
                        onChange={onSelectFile}
                        className={style.hiddenInput}
                      />

                      <br/>
                      <button className={`btn btn-primary ${style.btn}`} onClick={props.exportCompanyScenarios}
                        disabled={!(isMaster || isAdmin)}>
                        <i className="fas fa-fw fa-download"/> <Translate value="scenarios.Export"/>
                      </button>
                      <input style={{display: 'none'}} disabled={!(isMaster || isAdmin)} id="import-file-input" type="file"
                             onChange={importCompanyScenarios}/>
                      <label htmlFor="import-file-input" disabled={!(isMaster || isAdmin)} className={`btn btn-primary ${style.btn}`}>
                        <i className="fas fa-fw fa-upload"/> <Translate value="scenarios.Import"/>
                    </label>
                  </div>

               </div>
            </div>
          </div>

          {(isMaster || isAdmin) &&

            <div className="accordion" id="accordionExample">
              <div className="card">
                <div className="card-header active" id="headingOne">
                  <h2 className="mb-0">
                    <button 
                         className={`btn btn-primary ${style.btn}`} 
                         type="button"
                         onClick={() => setIsReposOpen(!isReposOpen)}
                         style={process.env.REACT_APP_HIDE_MANAGE_REPOS? { display: 'none' } : {}}
                    >
                      <Translate value="scenarios.ManageReposTitle"/>
                    </button>
                  </h2>
                </div>

                <Collapse isOpen={isReposOpen}>
                  <div className="card-body">
                    <Translate value="scenarios.ReposInstrux" dangerousHTML/>
                    <hr/>
                    <div className="row">
                      <div className="col-sm-5">
                        {loading && <LoadingLocal/>}
                        <div>
                          <div
                            className={'select-box'}
                            style={{height: '230px'}}
                          >
                            <div value="" hidden/>
                            {
                              repositories && repositories.sort(compareNames).map(repo => (
                                <div
                                  key={repo._id}
                                  value={repo._id}
                                  className={'select-box__variant ' + (currentRepository === repo._id ? 'select-box__variant--selected' : '')}
                                  onClick={() => handleRepoSelectChange(repo._id)}
                                >{repo.name}</div>
                              ))
                            }
                          </div>
                        </div>

                        <div className="row">
                          <div className="col-sm-6">
                            <button
                              className={`btn btn-primary ${style.btn}`}
                              onClick={addRepo}>
                              <i className={`fas fa-fw ${uploading ? 'fa-circle-o-notch fa-spin' : 'fa-plus' }`}/>
                              <Translate value="scenarios.AddRepo"/>
                            </button>
                          </div>
                          <div className="col-sm-6">
                            <button
                              className={`btn btn-primary ${style.btn}`}
                              onClick={removeRepo}>
                              <i className={`fas fa-fw ${uploading ? 'fa-circle-o-notch fa-spin' : 'fa-trash' }`}/>
                              <Translate value="scenarios.RemoveRepo"/>
                            </button>
                          </div>

                        </div>
                      </div>
                      <div className="col-sm-7">
                        {loading && <LoadingLocal/>}
                        <div>
                          <div
                            className={'select-box'}
                            style={{height: '230px'}}
                          >
                            <div value="" hidden/>
                            {
                              repoScenarios && repoScenarios.sort((a, b) => a.title > b.title).map(sim => (
                                <div
                                  key={sim._id}
                                  value={sim._id}
                                  className={'select-box__variant ' + (currentRepoSim === sim._id ? 'select-box__variant--selected' : '')}
                                  onDoubleClick={openEmbeddedFromRepo}
                                  onClick={() => handleRepoSimSelectChange(sim._id)}
                                >{sim.title}</div>
                              ))
                            }
                          </div>
                        </div>

                        <div style={{display: 'flex', justifyContent:'space-between'}}>
                          <button
                            className={`btn btn-primary ${style.btn}`}
                            onClick={openEmbeddedFromRepo}
                            style={{marginRight: '10px'}}
                          >
                            <i className="fas fa-fw fa-eye"/>
                            <Translate value="scenarios.Preview"/>
                          </button>

                          <button
                            className={`btn btn-primary ${style.btn}`}
                            onClick={() => dispatch(importRepoSimAction(currentRepository, currentRepoSim))}>
                            <i className={`fas fa-fw ${uploading ? 'fa-circle-o-notch fa-spin' : 'fa-upload' }`}/>
                            <Translate value="scenarios.ImportRepoSim"/>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </Collapse>
              </div>
            </div>
          }

        </div>
      </div>
    );
}

Scenarios.propTypes = {
  // Proptypes are less strictly needed in functional components if not using typescript, 
  // but good for documentation. Since we use hooks to get state, we don't need to define 
  // props that come from redux here, only parent passed props which seem to be none in the export default.
  // However, I will leave them out for now as we prefer concise conversion and they are not runtime enforced strictly in this setup usually.
};

export default Scenarios;
